// Delete hash from address bar
if (location.hash) {
    var hash = location.hash;
    history.replaceState({}, '', location.href.replace(hash, ''));
}

//const menu = document.querySelector('.header__menu');
const links_scroll = document.querySelectorAll('[href*="#"]');

links_scroll.forEach(e => {
    if (e.hash) {
        const el_hash = document.querySelector(e.hash);

        if (el_hash) {
            e.addEventListener('click', event => {
                event.preventDefault();

                //menu.classList.remove('header__menu_active');

                window.scrollTo({
                    top: el_hash.getBoundingClientRect().top + pageYOffset - 30,
                    left: 0,
                    behavior: 'smooth'
                });
            });
        }
    }
});

// Animating scroll to hash from another page
if (hash) {
    const el_hash = document.querySelector(hash);
    if (!!el_hash) {
        window.scrollTo({
            top: el_hash.getBoundingClientRect().top + pageYOffset,
            left: 0,
            behavior: 'smooth'
        });
    }
}
// END Animating scroll to hash from another page
